interface IConfig {
  languageArr: ILanguage[];
  language: string;
  sentryEnable: boolean;
  versionName: string;
  country: string;
}

interface ILanguage {
  key: string;
  name: string;
}

interface IConfigWithRegex {
  regex: RegExp;
  config: IConfig;
}

const configArr: IConfigWithRegex[] = [
  {
    regex: /-in/,
    config: {
      languageArr: [
        {
          key: 'en',
          name: 'English',
        },
      ],
      language: 'en',
      country: 'in',
      sentryEnable: true,
      versionName: 'lite',
    },
  },
  {
    regex: /-id/,
    config: {
      languageArr: [
        {
          key: 'en',
          name: 'English',
        },
        {
          key: 'id',
          name: 'Bahasa',
        },
      ],
      language: 'en',
      country: 'id',
      sentryEnable: true,
      versionName: 'lite',
    },
  },
];

const DEFAULT_CONFIG = configArr[0];

class ConfigEnv {
  private config: IConfig;

  constructor() {
    let defaultConfig = DEFAULT_CONFIG.config;
    this.config =
      typeof externalConfig !== 'undefined'
        ? { ...defaultConfig, ...externalConfig }
        : defaultConfig;
  }

  public init(): void {
    const hostname = location.hostname;

    configArr.forEach((item) => {
      if (item.regex.test(hostname)) {
        this.config = item.config;
      }
    });

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      this.config.sentryEnable = false;
      console.log('Disabled sentry forcely');
    }
    console.log('Config: ', this.config);
  }

  public get(): IConfig {
    return this.config;
  }

  public containLang(lang: string): Boolean {
    return this.config.languageArr.some((item) => item.key === lang);
  }
}

export const configEnv = new ConfigEnv();
